import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { ChipClickable } from '../../../Chips';

const styles = theme => ({
  root: {
  },
  description: {
    margin: theme.spacing.unit,
  }
});

const HeaderItem = ({ classes, label, description, action }) => {
  return(
    <div className={classes.root}>
      <ChipClickable
        label={label}
        handleClick={() => {
          action();
        }}/>
      <Typography className={classes.description}>
        {description}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(HeaderItem);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/HeaderItem.jsx